// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.thumb-size {
  width: 150px;
  height: 150px;
}

.cursor {
  cursor: pointer;
}

@media (max-width: 576px) {
  .thumb-size {
    width: 100px;
    height: 100px;
  }
}`, "",{"version":3,"sources":["webpack://./projects/zbs-app/src/app/modules/article/components/article-table/article-table.component.scss"],"names":[],"mappings":"AAAA;EACI,YAAA;EACA,aAAA;AACJ;;AAEA;EACI,eAAA;AACJ;;AAEA;EACI;IACI,YAAA;IACA,aAAA;EACN;AACF","sourcesContent":[".thumb-size {\r\n    width: 150px;\r\n    height: 150px;\r\n}\r\n\r\n.cursor {\r\n    cursor: pointer;\r\n}\r\n\r\n@media (max-width: 576px) {\r\n    .thumb-size {\r\n        width: 100px;\r\n        height: 100px;\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
